module.exports = __webpack_public_path__ + "static/media/twitter.04979782.svg";